import _ from 'lodash'
import moment from 'moment'

export const buildQuery = query => {
	const queryKeys = Object.keys(query)
	const sanitizedQuery = queryKeys.reduce((acc, k) => {
		if (query[k] === undefined) return acc
		acc[k] = sanitizeVal(query[k])
		return acc
	}, {})
	const keys = Object.keys(sanitizedQuery).sort((a, b) => getFilterKeyCost(a, sanitizedQuery[a]) - getFilterKeyCost(b, sanitizedQuery[b]))
	const hasOnlyUndefinedValues = queryKeys.length > 0 && keys.length === 0

	return {keys, sanitizedQuery, hasOnlyUndefinedValues}
}

const getFilterKeyCost = (key, val) => {
	if (key === 'dateRange') return 4
	if (isRange(val)) return 4
	if (key === 'id') return 0
	if (key.endsWith('_id')) return 1
	if (_.isArray(val)) return 3
	return 2
}

export const filterKeys = (keys, query, record) => {
	return keys.every(key => filterRecord(query[key], record[key]))
}

const isRange = i => _.isObject(i) && i.start && i.start instanceof moment

const filterRecord = (queryVal, recordVal) => {
	recordVal = sanitizeVal(recordVal)
	if (_.isArray(queryVal) || _.isArray(recordVal)) return filterArrays(queryVal, recordVal)
	if (isRange(queryVal) || isRange(recordVal)) return filterRanges(queryVal, recordVal)
	return _.isEqual(queryVal, recordVal)
}

const filterRanges = (queryVal, recordVal) => {
	if (_.isFunction(recordVal)) recordVal = recordVal()

	const queryIsRange = isRange(queryVal)
	const recordIsRange = isRange(recordVal)

	if (queryIsRange && recordIsRange) return queryVal.overlaps(recordVal)

	if (queryIsRange && _.isString(recordVal)) return filterDateStringInRange(recordVal, queryVal)
	if (_.isString(queryVal) && recordIsRange) return filterDateStringInRange(queryVal, recordVal)

	return
}

const filterDateStringInRange = (dateString, range) => {
	const startDate = range.start.format('YYYY-MM-DD')
	const endDate = range.end.format('YYYY-MM-DD')
	return startDate <= dateString && dateString <= endDate
}

export const sanitizeVal = val => {
	if (val instanceof moment) return val.format('YYYY-MM-DD')
	if (_.isString(val)) return sanitizeString(val)
	return val
}

const sanitizeString = val => {
	if (!isNaN(val)) return Number(val)
	return val
}

function filterArrays(arr1, arr2) {
	if (_.isArray(arr1) && _.isArray(arr2)) return arr1.some(item => arr2.includes(item))
	if (_.isArray(arr1)) return arr1.includes(arr2)
	if (_.isArray(arr2)) return arr2.includes(arr1)
}
